import { render, staticRenderFns } from "./v-otzivClient.vue?vue&type=template&id=58cde7bd&"
import script from "./v-otzivClient.vue?vue&type=script&lang=js&"
export * from "./v-otzivClient.vue?vue&type=script&lang=js&"
import style0 from "./v-otzivClient.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports